export const SET_TOPLISTS = 'CANVAS/TOPLISTS/SET_TOPLISTS';
export const SET_UNSUBSCRIBE_HANDLER = 'CANVAS/TOPLISTS/SET_UNSUBSCRIBE_HANDLER';
export const SELECT = 'CANVAS/TOPLISTS/SELECT';
export const UNSELECT = 'CANVAS/TOPLISTS/SELECT';
export const EDIT = 'CANVAS/TOPLISTS/EDIT';
export const END_EDIT = 'CANVAS/TOPLISTS/END_EDIT';
export const CREATE = 'CANVAS/TOPLISTS/CREATE';
export const SET = 'CANVAS/TOPLISTS/SET';
export const UPDATING = 'CANVAS/TOPLISTS/UPDATING';